import { cn } from '@anytag/shared-utils';
import { FilterAction } from '@anytag/shared-types';
import { Filter } from '@anytag/shared-molecules';
import { Template, TemplateProps } from './Template';
import { InfluencerXhsPostsFilterFormValues } from './schemaTypes';

export interface InfluencerXhsPostsFilterProps
  extends FilterAction<InfluencerXhsPostsFilterFormValues>,
    Omit<TemplateProps, 'onSubmit'> {
  className?: string;
}

export const InfluencerXhsPostsFilter = ({
  filter,
  setFilter,
  className,
  ...templateProps
}: InfluencerXhsPostsFilterProps) => (
  <Filter.Provider onSubmit={setFilter} values={filter} className={cn('px-4 shadow-list', className)}>
    <Template {...templateProps} />
  </Filter.Provider>
);

export * from './schemaTypes';
